var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"calc(100vh - 84px)"}},[_c('a-button',{on:{"click":_vm.jumpRouter}},[_vm._v("跳转到园外叫料管理")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }